// Page Styles
import '../../../styles/track-tasks.scss';
import '../../../styles/vendor/signin.css';

// Adds Clippy JS for fun
import '../../vendor/clippy/clippy';
import '../../vendor/clippy/clippy.css';
import './ui/clippy';

import '../ui_global';

import { renderTaskCardHTML } from './ui/taskCard';
import { renderPinnedTaskListHTML } from './ui/pinnedTaskList';
import { getPinArrayFromStorage } from './utils';

import { getTaskPayload } from '../../asana/api-get-task';

const form = document.querySelector('form');
const errorAnchorElm = document.querySelector('.error-message');
const tasksRootElm = document.querySelector('#tasks-root');

/**  START Initialization Components
 ------------------------------------------------------------------------*/
addPinnedTasksToDOM();
passTaskIdFormUrlToInput();

/**  START search task
 ------------------------------------------------------------------------*/

form.addEventListener('submit', e => {
  e.preventDefault();

  const inputVal_taskId = form[0].value;

  // Hide the error anchor id state was set to display.
  errorAnchorElm.classList.add('d-none');

  // Disable inputs while loading.
  disableInputStateToggle(form);

  $.ajax(getTaskPayload(inputVal_taskId))
    .done(successfulPost)
    .catch(failedPost);
});

function failedPost(err) {
  const errorResp = JSON.parse(err.responseText).errors[0].message;

  // Reformat and write error message to DOM.
  errorAnchorElm.innerText = errorResp.match(/[^task:\s]\w+/gi).join(' ');
  // Show the error anchor id state was set to d-none.
  errorAnchorElm.classList.remove('d-none');

  // Enable inputs after loading.
  disableInputStateToggle(form);
}

function successfulPost(response) {
  // Render the response data to the card anchor.
  tasksRootElm.innerHTML = renderTaskCardHTML(response.data);

  // Reset the state of the form.
  form.reset();

  // Enable inputs after loading.
  disableInputStateToggle(form);

  // Add event lister to pin buttons.
  bindPinToggleListenerToTaskCards();

  syncPinnedItemsWithRemote(response);
}

function disableInputStateToggle(formElm) {
  const inputs = formElm.querySelectorAll('input, button[type="submit"]');
  const spinner = formElm.querySelector('.loading-spinner');

  const searchInput = form[0];
  const searchBtn = form[1];

  // Remove animations if applicable (used when ID is in URL).
  searchInput.classList.remove('focus-element-psuedo');
  searchBtn.classList.remove('animate-border-pulse');

  spinner.classList.toggle('d-none');

  inputs.forEach(input => {
    input.disabled = !input.disabled;
  });
}

/**  START pin task
 ------------------------------------------------------------------------*/
function bindPinToggleListenerToTaskCards() {
  const pinTaskElm = document.querySelectorAll(
    '.request-card span[data-task-id]'
  );
  pinTaskElm.forEach(pin => {
    pin.addEventListener('click', e => {
      const pinElm = e.target;
      const { taskId, taskName } = pinElm.dataset;

      // Will be a Boolean
      const pinState = JSON.parse(pinElm.dataset.pinState);

      const { pinEmoji, storeAction } = toggleCardPinState(pinState);

      // Set the pin emoji.
      pinElm.innerText = pinEmoji;

      // Switch the pinState.
      pinElm.dataset.pinState = !pinState;

      // Add/Remove task ID.
      editPinnedTaskIdLocally({ taskId, taskName }, storeAction);

      addPinnedTasksToDOM();
    });
  });
}

function toggleCardPinState(pinState) {
  if (!pinState) {
    return {
      pinEmoji: '📍',
      storeAction: 'setItem'
    };
  } else {
    return {
      pinEmoji: '📌',
      storeAction: 'removeItem'
    };
  }
}

function editPinnedTaskIdLocally(taskObj, storeState) {
  let pinArray = getPinArrayFromStorage();

  storeState === 'setItem'
    ? pinArray.push(taskObj)
    : (pinArray = pinArray.filter(local => local.taskId !== taskObj.taskId));

  writeToLocalStorage(pinArray);
}

function writeToLocalStorage(value, localKey = 'pinnedTasks') {
  localStorage.setItem(localKey, JSON.stringify(value));
  console.log('💾 Current local state', value);
}

function addPinnedTasksToDOM() {
  const pinnedTasksRootElm = document.querySelector('.pinned-tasks-list');

  pinnedTasksRootElm.innerHTML = renderPinnedTaskListHTML();
  tasksRootElm.classList.remove('d-none');

  // When pinned link is clicked, add taskID to search input.
  pinnedTasksRootElm.addEventListener('click', e => {
    const pinnedLink = e.target.closest('.pinned-item-link');

    if (!pinnedLink) return;

    // Get hash from the URL and set as input value.
    form[0].value = getTaskFormUrl(pinnedLink.href);

    // Focus search input.
    form[0].focus();
  });

  const pinTaskElm = document.querySelectorAll(
    '.pinned-tasks-list span[data-task-id]'
  );

  // When trashcan emoji is clicked, remove item form localStorage and DOM
  pinTaskElm.forEach(pin => {
    pin.addEventListener('click', e => {
      const pinElm = e.target;
      const { taskId, taskName } = pinElm.dataset;

      // Will be a Boolean
      const pinState = JSON.parse(pinElm.dataset.pinState);

      const { storeAction } = toggleCardPinState(pinState);

      // Remove task ID.
      editPinnedTaskIdLocally({ taskId, taskName }, storeAction);

      addPinnedTasksToDOM();
    });
  });
}

function passTaskIdFormUrlToInput() {
  const taskID = getTaskFormUrl(location.href);
  const searchInput = form[0];
  const searchBtn = form[1];

  if (!taskID) return null;

  searchInput.value = taskID;

  searchInput.classList.add('focus-element-psuedo');
  searchBtn.classList.add('animate-border-pulse');
}

function getTaskFormUrl(urlString) {
  const url = new URL(urlString);
  if (!url.hash) return null;

  return url.hash.match(/\d+/)[0];
}

function syncPinnedItemsWithRemote({ data }) {
  const { gid: taskId, name: taskName } = data;
  let pinArray = getPinArrayFromStorage();

  pinArray = pinArray.map(taskObj => {
    if (taskObj.taskId === taskId) {
      return { taskId, taskName };
    } else {
      return taskObj;
    }
  });

  writeToLocalStorage(pinArray);
  addPinnedTasksToDOM();
}
